import { NavLink, useNavigate } from "react-router-dom";
import { api } from "../services";
import type { Session } from "../services/types";

// The rail. Text only. Keys match backend/modules/lead_gen/sections.py so the
// grant filter and the server agree on what a section is called.

const ITEMS = [
  { to: "/", key: "dashboard", label: "Home" },
  { to: "/cold", key: "cold", label: "Cold email" },
  { to: "/followups", key: "followups", label: "Follow-ups" },
  { to: "/replies", key: "replies", label: "Replies" },
  { to: "/bookings", key: "bookings", label: "Bookings" },
  { to: "/audits", key: "audits", label: "Audits" },
  { to: "/admin", key: "admin", label: "Admin" },
];

interface SideNavProps {
  session: Session;
}

export function SideNav({ session }: SideNavProps) {
  const navigate = useNavigate();

  async function onLogout() {
    await api.auth.logout();
    navigate("/login", { replace: true });
  }

  // Show only the sections this account was granted. Admins get everything. A session with no
  // sections list predates permissions and shows everything; the server still checks per request.
  const granted = session.sections;
  const items =
    session.role === "admin" || !Array.isArray(granted)
      ? ITEMS
      : ITEMS.filter((item) => granted.includes(item.key));

  return (
    <aside className="rail">
      <div className="fbrand">Dime Motion</div>
      <nav aria-label="Sections">
        {items.map(({ to, key, label }) => (
          <NavLink
            key={key}
            to={to}
            end={to === "/"}
            className={({ isActive }) => (isActive ? "active" : undefined)}
          >
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="who">
        <div className="email">{session.email}</div>
        <button type="button" className="site" onClick={onLogout}>Log out</button>
      </div>
    </aside>
  );
}
